import {
  GET_PRODUCT_LIST,
  GET_PRODUCT_LIST_SUCCESS,
  GET_PRODUCT_LIST_FAILURE,
  GET_PRODUCT_SELF_SERVE_WIDGET_RENDER,
  GET_PRODUCT_SELF_SERVE_WIDGET_RENDER_SUCCESS,
  GET_PRODUCT_SELF_SERVE_WIDGET_RENDER_FAILURE,
  POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK,
  POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK_SUCCESS,
  POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK_FAILURE,
  POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY,
  POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY_SUCCESS,
  POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY_FAILURE,
  GET_PRODUCT_LIST_NEW_API_CALL,
  GET_PRODUCT_LIST_NEW_API_CALL_SUCCESS,
  GET_PRODUCT_LIST_NEW_API_CALL_FAILURE,
  GET_PRODUCT_DETAIL,
  GET_PRODUCT_DETAIL_SUCCESS,
  GET_PRODUCT_DETAIL_FAILURE,
  ADD_PRODUCT,
  ADD_PRODUCT_SUCCESS,
  ADD_PRODUCT_FAILURE,
  UPDATE_PRODUCT_CRM,
  UPDATE_PRODUCT_SUCCESS_CRM,
  UPDATE_PRODUCT_FAILURE_CRM,
  DELETE_PRODUCT,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAILURE,
  SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING,
  SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING_SUCCESS,
  SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING_FAILURE,
  SEARCH_PRODUCTS_PRICING,
  SEARCH_PRODUCTS_PRICING_SUCCESS,
  SEARCH_PRODUCTS_PRICING_FAILURE,
  CREATE_PRODUCTS_PRICING,
  CREATE_PRODUCTS_PRICING_SUCCESS,
  CREATE_PRODUCTS_PRICING_FAILURE,
  UPDATE_PRODUCTS_PRICING,
  UPDATE_PRODUCTS_PRICING_SUCCESS,
  UPDATE_PRODUCTS_PRICING_FAILURE,
  DELETE_PRODUCTS_PRICING,
  DELETE_PRODUCTS_PRICING_SUCCESS,
  DELETE_PRODUCTS_PRICING_FAILURE,
  SEARCH_PRODUCT_PRICE,
  SEARCH_PRODUCT_PRICE_SUCCESS,
  SEARCH_PRODUCT_PRICE_FAILURE,
  CREATE_PRODUCT_PRICE,
  CREATE_PRODUCT_PRICE_SUCCESS,
  CREATE_PRODUCT_PRICE_FAILURE,
  UPDATE_PRODUCT_PRICE,
  UPDATE_PRODUCT_PRICE_SUCCESS,
  UPDATE_PRODUCT_PRICE_FAILURE,
  DELETE_PRODUCT_PRICE,
  DELETE_PRODUCT_PRICE_SUCCESS,
  DELETE_PRODUCT_PRICE_FAILURE,
  GET_PRODUCTS_PRICING_DATA,
  GET_PRODUCTS_PRICING_DATA_SUCCESS,
  GET_PRODUCTS_PRICING_DATA_FAILURE,
  GET_PRODUCTS_RECENT_ACTIVITY,
  GET_PRODUCTS_RECENT_ACTIVITY_SUCCESS,
  GET_PRODUCTS_RECENT_ACTIVITY_FAILURE,
  GET_PRODUCTS_PRICING_LIST,
  GET_PRODUCTS_PRICING_LIST_SUCCESS,
  GET_PRODUCTS_PRICING_LIST_FAILURE,
  GET_FOOD_ALLERGEN_LIST,
  GET_FOOD_ALLERGEN_LIST_SUCCESS,
  GET_FOOD_ALLERGEN_LIST_FAILURE,
  GET_FOOD_ALLERGEN_DATA,
  GET_FOOD_ALLERGEN_DATA_SUCCESS,
  GET_FOOD_ALLERGEN_DATA_FAILURE,
  CREATE_FOOD_ALLERGEN,
  CREATE_FOOD_ALLERGEN_SUCCESS,
  CREATE_FOOD_ALLERGEN_FAILURE,
  UPDATE_FOOD_ALLERGEN,
  UPDATE_FOOD_ALLERGEN_SUCCESS,
  UPDATE_FOOD_ALLERGEN_FAILURE,
  DELETE_FOOD_ALLERGEN,
  DELETE_FOOD_ALLERGEN_SUCCESS,
  DELETE_FOOD_ALLERGEN_FAILURE,
  GET_FOOD_DIET_TYPE_LIST,
  GET_FOOD_DIET_TYPE_LIST_SUCCESS,
  GET_FOOD_DIET_TYPE_LIST_FAILURE,
  GET_FOOD_DIET_TYPE_DATA,
  GET_FOOD_DIET_TYPE_DATA_SUCCESS,
  GET_FOOD_DIET_TYPE_DATA_FAILURE,
  CREATE_FOOD_DIET_TYPE,
  CREATE_FOOD_DIET_TYPE_SUCCESS,
  CREATE_FOOD_DIET_TYPE_FAILURE,
  UPDATE_FOOD_DIET_TYPE,
  UPDATE_FOOD_DIET_TYPE_SUCCESS,
  UPDATE_FOOD_DIET_TYPE_FAILURE,
  DELETE_FOOD_DIET_TYPE,
  DELETE_FOOD_DIET_TYPE_SUCCESS,
  DELETE_FOOD_DIET_TYPE_FAILURE,
  GET_PRODUCT_ATTRIBUTE_LIST,
  GET_PRODUCT_ATTRIBUTE_LIST_SUCCESS,
  GET_PRODUCT_ATTRIBUTE_LIST_FAILURE,
  GET_PRODUCT_ATTRIBUTE_DATA,
  GET_PRODUCT_ATTRIBUTE_DATA_SUCCESS,
  GET_PRODUCT_ATTRIBUTE_DATA_FAILURE,
  CREATE_PRODUCT_ATTRIBUTE,
  CREATE_PRODUCT_ATTRIBUTE_SUCCESS,
  CREATE_PRODUCT_ATTRIBUTE_FAILURE,
  UPDATE_PRODUCT_ATTRIBUTE,
  UPDATE_PRODUCT_ATTRIBUTE_SUCCESS,
  UPDATE_PRODUCT_ATTRIBUTE_FAILURE,
  DELETE_PRODUCT_ATTRIBUTE,
  DELETE_PRODUCT_ATTRIBUTE_SUCCESS,
  DELETE_PRODUCT_ATTRIBUTE_FAILURE,
  GET_PRODUCT_ATTRIBUTE_VALUE_LIST,
  GET_PRODUCT_ATTRIBUTE_VALUE_LIST_SUCCESS,
  GET_PRODUCT_ATTRIBUTE_VALUE_LIST_FAILURE,
  GET_PRODUCT_ATTRIBUTE_VALUE_DATA,
  GET_PRODUCT_ATTRIBUTE_VALUE_DATA_SUCCESS,
  GET_PRODUCT_ATTRIBUTE_VALUE_DATA_FAILURE,
  CREATE_PRODUCT_ATTRIBUTE_VALUE,
  CREATE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS,
  CREATE_PRODUCT_ATTRIBUTE_VALUE_FAILURE,
  UPDATE_PRODUCT_ATTRIBUTE_VALUE,
  UPDATE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS,
  UPDATE_PRODUCT_ATTRIBUTE_VALUE_FAILURE,
  DELETE_PRODUCT_ATTRIBUTE_VALUE,
  DELETE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS,
  DELETE_PRODUCT_ATTRIBUTE_VALUE_FAILURE,
  GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST,
  GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST_SUCCESS,
  GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST_FAILURE,
  GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA,
  GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA_SUCCESS,
  GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA_FAILURE,
  CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE,
  CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS,
  CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE,
  UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE,
  UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS,
  UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE,
  DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE,
  DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS,
  DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE,
} from "./actionType";

// Actions for productselfservewidget/render/:id
export const getProductSelfServeWidgetRender = (payload) => ({
  type: GET_PRODUCT_SELF_SERVE_WIDGET_RENDER,
  payload,
});

export const getProductSelfServeWidgetRenderSuccess = (payload) => ({
  type: GET_PRODUCT_SELF_SERVE_WIDGET_RENDER_SUCCESS,
  payload,
});

export const getProductSelfServeWidgetRenderFailure = () => ({
  type: GET_PRODUCT_SELF_SERVE_WIDGET_RENDER_FAILURE,
});

// Actions for productselfserve/public/book/:id
export const postProductSelfServePublicBook = (payload) => ({
  type: POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK,
  payload,
});
export const postProductSelfServePublicBookSuccess = (payload) => ({
  type: POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK_SUCCESS,
  payload,
});
export const postProductSelfServePublicBookFailure = () => ({
  type: POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK_FAILURE,
});

// Actions for productselfservewidget/checkavailability/:id
export const postProductSelfServeWidgetCheckAvailability = (payload) => ({
  type: POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY,
  payload,
});
export const postProductSelfServeWidgetCheckAvailabilitySuccess = (payload) => ({
  type: POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY_SUCCESS,
  payload,
});
export const postProductSelfServeWidgetCheckAvailabilityFailure = () => ({
  type: POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY_FAILURE,
});

// Actions for getting product list
export const getProductList = () => {

  return {
    type: GET_PRODUCT_LIST,
  };
};

export const getProductListSuccess = (products) => ({
  type: GET_PRODUCT_LIST_SUCCESS,
  payload: products,
});

export const getProductListFailure = () => ({
  type: GET_PRODUCT_LIST_FAILURE,
});

// Actions for getting product detail
export const getProductDetail = (id) => ({
  type: GET_PRODUCT_DETAIL,
  payload: id,
});

export const getProductDetailSuccess = (product) => ({
  type: GET_PRODUCT_DETAIL_SUCCESS,
  payload: product,
});

export const getProductDetailFailure = () => ({
  type: GET_PRODUCT_DETAIL_FAILURE,
});

// Actions for adding product
export const addProduct = (product) => ({
  type: ADD_PRODUCT,
  payload: product,
});

export const addProductSuccess = (product) => ({
  type: ADD_PRODUCT_SUCCESS,
  payload: product,
});

export const addProductFailure = () => ({
  type: ADD_PRODUCT_FAILURE,
});

// Actions for updating product
export const updateProduct = (product) => ({
  type: UPDATE_PRODUCT_CRM,
  payload: product,
});

export const updateProductSuccess = (product) => ({
  type: UPDATE_PRODUCT_SUCCESS_CRM,
  payload: product,
});

export const updateProductFailure = () => ({
  type: UPDATE_PRODUCT_FAILURE_CRM,
});

// Actions for deleting product

export const deleteProduct = (id) => ({
  type: DELETE_PRODUCT,
  payload: id,
});

export const deleteProductSuccess = (id) => ({
  type: DELETE_PRODUCT_SUCCESS,
  payload: id,
});

export const deleteProductFailure = () => ({
  type: DELETE_PRODUCT_FAILURE,
});

// Actions for searching products allowed time tracking

export const searchProductsAllowedTimeTracking = (payload) => ({
  type: SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING,
  payload,
});

export const searchProductsAllowedTimeTrackingSuccess = (payload) => ({
  type: SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING_SUCCESS,
  payload,
});

export const searchProductsAllowedTimeTrackingFailure = (payload) => ({
  type: SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING_FAILURE,
  payload,
});

// Actions for searching products pricing
export const searchProductsPricing = (payload) => ({
  type: SEARCH_PRODUCTS_PRICING,
  payload,
});

export const searchProductsPricingSuccess = (payload) => ({
  type: SEARCH_PRODUCTS_PRICING_SUCCESS,
  payload,
});

export const searchProductsPricingFailure = (payload) => ({
  type: SEARCH_PRODUCTS_PRICING_FAILURE,
  payload,
});

// Actions for creating products pricing
export const createProductsPricing = (payload) => ({
  type: CREATE_PRODUCTS_PRICING,
  payload,
});

export const createProductsPricingSuccess = (payload) => ({
  type: CREATE_PRODUCTS_PRICING_SUCCESS,
  payload,
});

export const createProductsPricingFailure = (payload) => ({
  type: CREATE_PRODUCTS_PRICING_FAILURE,
  payload,
});

// Actions for updating products pricing
export const updateProductsPricing = (payload) => ({
  type: UPDATE_PRODUCTS_PRICING,
  payload,
});

export const updateProductsPricingSuccess = (payload) => ({
  type: UPDATE_PRODUCTS_PRICING_SUCCESS,
  payload,
});

export const updateProductsPricingFailure = (payload) => ({
  type: UPDATE_PRODUCTS_PRICING_FAILURE,
  payload,
});

// Actions for deleting products pricing
export const deleteProductsPricing = (payload) => ({
  type: DELETE_PRODUCTS_PRICING,
  payload,
});

export const deleteProductsPricingSuccess = (payload) => ({
  type: DELETE_PRODUCTS_PRICING_SUCCESS,
  payload,
});

export const deleteProductsPricingFailure = (payload) => ({
  type: DELETE_PRODUCTS_PRICING_FAILURE,
  payload,
});

// Task 24858 - ProductPrice: the product's own dated price schedule. Reading it
// needs no action of its own, product/data already returns the whole schedule as
// productprice_data; these are the writes that were missing.
export const searchProductPrice = (payload) => ({
  type: SEARCH_PRODUCT_PRICE,
  payload,
});

export const searchProductPriceSuccess = (payload) => ({
  type: SEARCH_PRODUCT_PRICE_SUCCESS,
  payload,
});

export const searchProductPriceFailure = (payload) => ({
  type: SEARCH_PRODUCT_PRICE_FAILURE,
  payload,
});

export const createProductPrice = (payload) => ({
  type: CREATE_PRODUCT_PRICE,
  payload,
});

export const createProductPriceSuccess = (payload) => ({
  type: CREATE_PRODUCT_PRICE_SUCCESS,
  payload,
});

export const createProductPriceFailure = (payload) => ({
  type: CREATE_PRODUCT_PRICE_FAILURE,
  payload,
});

export const updateProductPrice = (payload) => ({
  type: UPDATE_PRODUCT_PRICE,
  payload,
});

export const updateProductPriceSuccess = (payload) => ({
  type: UPDATE_PRODUCT_PRICE_SUCCESS,
  payload,
});

export const updateProductPriceFailure = (payload) => ({
  type: UPDATE_PRODUCT_PRICE_FAILURE,
  payload,
});

export const deleteProductPrice = (payload) => ({
  type: DELETE_PRODUCT_PRICE,
  payload,
});

export const deleteProductPriceSuccess = (payload) => ({
  type: DELETE_PRODUCT_PRICE_SUCCESS,
  payload,
});

export const deleteProductPriceFailure = (payload) => ({
  type: DELETE_PRODUCT_PRICE_FAILURE,
  payload,
});

// Actions for getting products pricing data
export const getProductsPricingData = (payload) => ({
  type: GET_PRODUCTS_PRICING_DATA,
  payload,
});

export const getProductsPricingDataSuccess = (payload) => ({
  type: GET_PRODUCTS_PRICING_DATA_SUCCESS,
  payload,
});

export const getProductsPricingDataFailure = (payload) => ({
  type: GET_PRODUCTS_PRICING_DATA_FAILURE,
  payload,
});

// Actions for getting products recent activity
export const getProductsRecentActivity = (payload) => ({
  type: GET_PRODUCTS_RECENT_ACTIVITY,
  payload,
});

export const getProductsRecentActivitySuccess = (payload) => ({
  type: GET_PRODUCTS_RECENT_ACTIVITY_SUCCESS,
  payload,
});

export const getProductsRecentActivityFailure = (payload) => ({
  type: GET_PRODUCTS_RECENT_ACTIVITY_FAILURE,
  payload,
});

// Actions for getting products pricing list
export const getProductsPricingList = () => ({
  type: GET_PRODUCTS_PRICING_LIST,
});

export const getProductsPricingListSuccess = (payload) => ({
  type: GET_PRODUCTS_PRICING_LIST_SUCCESS,
  payload,
});

export const getProductsPricingListFailure = (payload) => ({
  type: GET_PRODUCTS_PRICING_LIST_FAILURE,
  payload,
});

// Actions for getting product list
export const getProductListNewApiCall = () => ({
  type: GET_PRODUCT_LIST_NEW_API_CALL,
});

export const getProductListNewApiCallSuccess = (products) => ({
  type: GET_PRODUCT_LIST_NEW_API_CALL_SUCCESS,
  payload: products,
});

export const getProductListNewApiCallFailure = () => ({
  type: GET_PRODUCT_LIST_NEW_API_CALL_FAILURE,
});

// Actions for food allergen list
// Task 24831 - optional token. A guest reading a pre-order menu is
// authenticated by an x-token-key, not a session, and these two lookups feed
// the allergen and diet pills on that menu. Called without one everywhere
// else, so every existing caller is unchanged.
export const getFoodAllergenList = (token) => ({
  type: GET_FOOD_ALLERGEN_LIST,
  payload: token,
});

export const getFoodAllergenListSuccess = (payload) => ({
  type: GET_FOOD_ALLERGEN_LIST_SUCCESS,
  payload,
});

export const getFoodAllergenListFailure = (payload) => ({
  type: GET_FOOD_ALLERGEN_LIST_FAILURE,
  payload,
});

// Actions for food allergen data
export const getFoodAllergenData = (payload) => ({
  type: GET_FOOD_ALLERGEN_DATA,
  payload,
});

export const getFoodAllergenDataSuccess = (payload) => ({
  type: GET_FOOD_ALLERGEN_DATA_SUCCESS,
  payload,
});

export const getFoodAllergenDataFailure = (payload) => ({
  type: GET_FOOD_ALLERGEN_DATA_FAILURE,
  payload,
});

// Actions for creating food allergen
export const createFoodAllergen = (payload) => ({
  type: CREATE_FOOD_ALLERGEN,
  payload,
});

export const createFoodAllergenSuccess = (payload) => ({
  type: CREATE_FOOD_ALLERGEN_SUCCESS,
  payload,
});

export const createFoodAllergenFailure = (payload) => ({
  type: CREATE_FOOD_ALLERGEN_FAILURE,
  payload,
});

// Actions for updating food allergen
export const updateFoodAllergen = (payload) => ({
  type: UPDATE_FOOD_ALLERGEN,
  payload,
});

export const updateFoodAllergenSuccess = (payload) => ({
  type: UPDATE_FOOD_ALLERGEN_SUCCESS,
  payload,
});

export const updateFoodAllergenFailure = (payload) => ({
  type: UPDATE_FOOD_ALLERGEN_FAILURE,
  payload,
});

// Actions for deleting food allergen
export const deleteFoodAllergen = (payload) => ({
  type: DELETE_FOOD_ALLERGEN,
  payload,
});

export const deleteFoodAllergenSuccess = (payload) => ({
  type: DELETE_FOOD_ALLERGEN_SUCCESS,
  payload,
});

export const deleteFoodAllergenFailure = (payload) => ({
  type: DELETE_FOOD_ALLERGEN_FAILURE,
  payload,
});

// Actions for food diet type list
// Task 24831 - see getFoodAllergenList above.
export const getFoodDietTypeList = (token) => ({
  type: GET_FOOD_DIET_TYPE_LIST,
  payload: token,
});

export const getFoodDietTypeListSuccess = (payload) => ({
  type: GET_FOOD_DIET_TYPE_LIST_SUCCESS,
  payload,
});

export const getFoodDietTypeListFailure = (payload) => ({
  type: GET_FOOD_DIET_TYPE_LIST_FAILURE,
  payload,
});

// Actions for food diet type data
export const getFoodDietTypeData = (payload) => ({
  type: GET_FOOD_DIET_TYPE_DATA,
  payload,
});

export const getFoodDietTypeDataSuccess = (payload) => ({
  type: GET_FOOD_DIET_TYPE_DATA_SUCCESS,
  payload,
});

export const getFoodDietTypeDataFailure = (payload) => ({
  type: GET_FOOD_DIET_TYPE_DATA_FAILURE,
  payload,
});

// Actions for creating food diet type
export const createFoodDietType = (payload) => ({
  type: CREATE_FOOD_DIET_TYPE,
  payload,
});

export const createFoodDietTypeSuccess = (payload) => ({
  type: CREATE_FOOD_DIET_TYPE_SUCCESS,
  payload,
});

export const createFoodDietTypeFailure = (payload) => ({
  type: CREATE_FOOD_DIET_TYPE_FAILURE,
  payload,
});

// Actions for updating food diet type
export const updateFoodDietType = (payload) => ({
  type: UPDATE_FOOD_DIET_TYPE,
  payload,
});

export const updateFoodDietTypeSuccess = (payload) => ({
  type: UPDATE_FOOD_DIET_TYPE_SUCCESS,
  payload,
});

export const updateFoodDietTypeFailure = (payload) => ({
  type: UPDATE_FOOD_DIET_TYPE_FAILURE,
  payload,
});

// Actions for deleting food diet type
export const deleteFoodDietType = (payload) => ({
  type: DELETE_FOOD_DIET_TYPE,
  payload,
});

export const deleteFoodDietTypeSuccess = (payload) => ({
  type: DELETE_FOOD_DIET_TYPE_SUCCESS,
  payload,
});

export const deleteFoodDietTypeFailure = (payload) => ({
  type: DELETE_FOOD_DIET_TYPE_FAILURE,
  payload,
});

// Actions for product attribute list
export const getProductAttributeList = () => ({
  type: GET_PRODUCT_ATTRIBUTE_LIST,
});

export const getProductAttributeListSuccess = (payload) => ({
  type: GET_PRODUCT_ATTRIBUTE_LIST_SUCCESS,
  payload,
});

export const getProductAttributeListFailure = (payload) => ({
  type: GET_PRODUCT_ATTRIBUTE_LIST_FAILURE,
  payload,
});

// Actions for product attribute data
export const getProductAttributeData = (payload) => ({
  type: GET_PRODUCT_ATTRIBUTE_DATA,
  payload,
});

export const getProductAttributeDataSuccess = (payload) => ({
  type: GET_PRODUCT_ATTRIBUTE_DATA_SUCCESS,
  payload,
});

export const getProductAttributeDataFailure = (payload) => ({
  type: GET_PRODUCT_ATTRIBUTE_DATA_FAILURE,
  payload,
});

// Actions for creating product attribute
export const createProductAttribute = (payload) => ({
  type: CREATE_PRODUCT_ATTRIBUTE,
  payload,
});

export const createProductAttributeSuccess = (payload) => ({
  type: CREATE_PRODUCT_ATTRIBUTE_SUCCESS,
  payload,
});

export const createProductAttributeFailure = (payload) => ({
  type: CREATE_PRODUCT_ATTRIBUTE_FAILURE,
  payload,
});

// Actions for updating product attribute
export const updateProductAttribute = (payload) => ({
  type: UPDATE_PRODUCT_ATTRIBUTE,
  payload,
});

export const updateProductAttributeSuccess = (payload) => ({
  type: UPDATE_PRODUCT_ATTRIBUTE_SUCCESS,
  payload,
});

export const updateProductAttributeFailure = (payload) => ({
  type: UPDATE_PRODUCT_ATTRIBUTE_FAILURE,
  payload,
});

// Actions for deleting product attribute
export const deleteProductAttribute = (payload) => ({
  type: DELETE_PRODUCT_ATTRIBUTE,
  payload,
});

export const deleteProductAttributeSuccess = (payload) => ({
  type: DELETE_PRODUCT_ATTRIBUTE_SUCCESS,
  payload,
});

export const deleteProductAttributeFailure = (payload) => ({
  type: DELETE_PRODUCT_ATTRIBUTE_FAILURE,
  payload,
});

// Actions for product attribute value list
export const getProductAttributeValueList = () => ({
  type: GET_PRODUCT_ATTRIBUTE_VALUE_LIST,
});

export const getProductAttributeValueListSuccess = (payload) => ({
  type: GET_PRODUCT_ATTRIBUTE_VALUE_LIST_SUCCESS,
  payload,
});

export const getProductAttributeValueListFailure = (payload) => ({
  type: GET_PRODUCT_ATTRIBUTE_VALUE_LIST_FAILURE,
  payload,
});

// Actions for product attribute value data
export const getProductAttributeValueData = (payload) => ({
  type: GET_PRODUCT_ATTRIBUTE_VALUE_DATA,
  payload,
});

export const getProductAttributeValueDataSuccess = (payload) => ({
  type: GET_PRODUCT_ATTRIBUTE_VALUE_DATA_SUCCESS,
  payload,
});

export const getProductAttributeValueDataFailure = (payload) => ({
  type: GET_PRODUCT_ATTRIBUTE_VALUE_DATA_FAILURE,
  payload,
});

// Actions for creating product attribute value
export const createProductAttributeValue = (payload) => ({
  type: CREATE_PRODUCT_ATTRIBUTE_VALUE,
  payload,
});

export const createProductAttributeValueSuccess = (payload) => ({
  type: CREATE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS,
  payload,
});

export const createProductAttributeValueFailure = (payload) => ({
  type: CREATE_PRODUCT_ATTRIBUTE_VALUE_FAILURE,
  payload,
});

// Actions for updating product attribute value
export const updateProductAttributeValue = (payload) => ({
  type: UPDATE_PRODUCT_ATTRIBUTE_VALUE,
  payload,
});

export const updateProductAttributeValueSuccess = (payload) => ({
  type: UPDATE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS,
  payload,
});

export const updateProductAttributeValueFailure = (payload) => ({
  type: UPDATE_PRODUCT_ATTRIBUTE_VALUE_FAILURE,
  payload,
});

// Actions for deleting product attribute value
export const deleteProductAttributeValue = (payload) => ({
  type: DELETE_PRODUCT_ATTRIBUTE_VALUE,
  payload,
});

export const deleteProductAttributeValueSuccess = (payload) => ({
  type: DELETE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS,
  payload,
});

export const deleteProductAttributeValueFailure = (payload) => ({
  type: DELETE_PRODUCT_ATTRIBUTE_VALUE_FAILURE,
  payload,
});

// Actions for product attribute value price list
export const getProductAttributeValuePriceList = () => ({
  type: GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST,
});

export const getProductAttributeValuePriceListSuccess = (payload) => ({
  type: GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST_SUCCESS,
  payload,
});

export const getProductAttributeValuePriceListFailure = (payload) => ({
  type: GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST_FAILURE,
  payload,
});

// Actions for product attribute value price data
export const getProductAttributeValuePriceData = (payload) => ({
  type: GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA,
  payload,
});

export const getProductAttributeValuePriceDataSuccess = (payload) => ({
  type: GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA_SUCCESS,
  payload,
});

export const getProductAttributeValuePriceDataFailure = (payload) => ({
  type: GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA_FAILURE,
  payload,
});

// Actions for creating product attribute value price
export const createProductAttributeValuePrice = (payload) => ({
  type: CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE,
  payload,
});

export const createProductAttributeValuePriceSuccess = (payload) => ({
  type: CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS,
  payload,
});

export const createProductAttributeValuePriceFailure = (payload) => ({
  type: CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE,
  payload,
});

// Actions for updating product attribute value price
export const updateProductAttributeValuePrice = (payload) => ({
  type: UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE,
  payload,
});

export const updateProductAttributeValuePriceSuccess = (payload) => ({
  type: UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS,
  payload,
});

export const updateProductAttributeValuePriceFailure = (payload) => ({
  type: UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE,
  payload,
});

// Actions for deleting product attribute value price
export const deleteProductAttributeValuePrice = (payload) => ({
  type: DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE,
  payload,
});

export const deleteProductAttributeValuePriceSuccess = (payload) => ({
  type: DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS,
  payload,
});

export const deleteProductAttributeValuePriceFailure = (payload) => ({
  type: DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE,
  payload,
});
